var React = require('react');

function Phone (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M112.772 81.4843C105.731 81.4843 98.8183 80.3831 92.2672 78.2182C89.0571 77.1233 85.1109 78.1278 83.1517 80.14L70.2211 89.9012C55.2253 81.8964 45.9882 72.6623 38.0927 57.779L47.5667 45.1854C50.0282 42.7272 50.911 39.1365 49.8533 35.7673C47.679 29.1818 46.5746 22.2719 46.5746 15.2282C46.5749 10.1397 42.4352 6 37.347 6H16.2278C11.1397 6 7 10.1397 7 15.2279C7 73.5514 54.4488 121 112.772 121C117.86 121 122 116.86 122 111.772V90.7119C122 85.624 117.86 81.4843 112.772 81.4843Z","fill":"#333333"}));
}

Phone.defaultProps = {"width":"128","height":"128","viewBox":"0 0 128 128","fill":"none"};

module.exports = Phone;

Phone.default = Phone;
